/**
 * Subtracts or adds the difference between the ceiling
 * and the total of the parts to reach the ceiling.
 * @param ceiling - highest possible number
 * @param parts - array of numbers which should add up to the ceiling
 * @returns Parts with the largest remainder
 */
export function largestRemainder(ceiling, parts) {
    const total = parts.reduce((a, b) => a + b, 0);
    let difference = total - ceiling;
    // If difference is higher than the ceiling
    // Remove the difference between the parts using whole numbers
    if (difference > 0) {
        let index = 0;
        do {
            parts[index] -= 1;
            difference -= 1;
            index += 1;
        } while (difference != 0);
    }
    // If difference is lower than the ceiling
    // Divide the difference by the amount of parts with whole numbers
    if (difference < 0) {
        let index = 0;
        do {
            parts[index] += 1;
            difference += 1;
            index += 1;
        } while (difference != 0);
    }
    return parts;
}
